import { customElement, useView, PLATFORM } from 'aurelia-framework';
import { BindingEngine } from 'aurelia-binding';
import { widget } from '../widget-decorator';
import { WidgetBase } from '../widget-base';
import { CustomerService } from '../../services/customer-service';
import { property } from '../property-decorator';
import { WidgetPropertyType } from '../widget-property-type';


@customElement('report-date-widget')
@useView(PLATFORM.moduleName('./report-date-widget.html'))
@widget({ name: 'Report date', canUseInReport: true, canUseInDashboard: true, defaultWidth: 27, defaultHeight: 12 })
export class ReportDateWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
    this.title = 'Report date:';
    this.titleFontSize = 14;
  }

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number = 18;

  @property('Text')
  color?: string;

  @property('Text')
  hideFrom?: boolean;

  @property('Text', 'Alignment', WidgetPropertyType.List, [{ value: 'left', label: 'Left' }, { value: 'center', label: 'Center' }, { value: 'right', label: 'Right' }])
  textAlign?: 'left' | 'center' | 'right';

}
